import { useLocation } from "react-router-dom";

// iter68 F1 — permanent environment chip on ALL /admin pages.
// Priority: REACT_APP_ENVIRONMENT_LABEL env var, else hostname heuristic.
const detectEnv = () => {
  const label = process.env.REACT_APP_ENVIRONMENT_LABEL;
  if (label) return label.toUpperCase();
  const h = window.location.hostname;
  if (h.includes("preview") || h === "localhost" || h.startsWith("127.")) return "PREVIEW";
  return "PRODUCCIÓN";
};

export const EnvironmentBadge = () => {
  const { pathname } = useLocation();
  if (!pathname.startsWith("/admin")) return null;
  const env = detectEnv();
  const isProd = env === "PRODUCCIÓN" || env === "PRODUCTION";
  return (
    <div
      className={`fixed bottom-3 right-3 z-[9999] px-3 py-1.5 rounded-full text-[11px] font-bold border shadow-lg backdrop-blur-sm cursor-help ${
        isProd
          ? "bg-emerald-500/20 border-emerald-400/50 text-emerald-300"
          : "bg-orange-500/20 border-orange-400/50 text-orange-300"
      }`}
      title="Este entorno tiene su propia base de datos."
      data-testid="environment-badge"
    >
      {isProd ? "🟢 PRODUCCIÓN" : "🟠 PREVIEW"}
    </div>
  );
};

export default EnvironmentBadge;
